class exports.StepTransition

    constructor: (handler, to, fromNav) ->

        debugLog('new StepTransition')

        @to = to
        @fromNav = fromNav ? false
        @skippedStepIDs = []

        # put errors here and displayErrors() will display them all at once
        @errors = []

        # For some reason the instanceof below this fails if
        # this isn't loaded here (loading it at the top of the file
        # makes the instanceof fail. I dunno.)
        SppHandler = App.loadClass 'grower::handlers/placement/SppHandler'


        if handler instanceof SppHandler
            # in this case there is no fromHandler, so we will skip the leaving,
            # saving, and validation logic, and just load the step
            @sppHandler = handler
            @taffy = @sppHandler.taffyObjects

            @loadToStep()

        else
            @fromHandler = handler
            @sppHandler = @fromHandler.parent

            # TODO: we probably shouldn't just combine taffy objects because
            # they probably have colliding key names :/

            @taffy = $.extend @fromHandler.taffyObjects, @sppHandler.taffyObjects

            @from = @fromHandler.num
            @forward = (@to > @from)

            @start()


    start: () ->
        # update the fieldsAspects in the SPP's Taffy DB
        @fromHandler.updateFieldsAspects()

        # determine if we need to skip any steps
        @checkSkipConditions()

        # call the step's beforeLeave() method if it has one
        if @fromHandler.beforeLeave?
            # we can stop here if needed
            if not @handleResponse @fromHandler.beforeLeave() then return

        # send the ajax request and do the rest of the transition
        @autosave()


    checkSkipConditions: () ->
        # check all the steps to see if any need to be skipped first
        for step in @taffy.steps().get()

            highest_visited_step = @sppHandler.getHighestVisitedStep()
            if @to > highest_visited_step
                highest_visited_step = @to

            # call the step's skipConditions() method if it has one
            if step.skipConditions?() and step.step_order <= highest_visited_step

                # mark the step as skipped
                step.skipped(true)
                @skippedStepIDs.push(step.id)

                # mark its aspects as skipped as well
                @taffy.fieldsAspects( steps_id: step.id ).update( skip: true )

            else
                step.skipped(false)
                @skippedStepIDs = @skippedStepIDs.filter (id) -> id isnt step.id

        @skipSteps()


    skipSteps: () ->
        toStep = @taffy.steps( step_order: @to ).first()

        # if toStep is skipped, update @to the next one
        if toStep.skipped()

            # if using the next/back buttons, skip the step entirely,
            # otherwise we'll display a message saying the step is not needed
            if not @fromNav

                if @forward
                    @to += 1
                else
                    @to -= 1

                @checkSkipConditions()



    handleResponse: (response) ->
        # this method should handle any response from the ajax call to autosave
        # or from a custom afterEnter() or beforeLeave() method

        # if we didn't get a response, just move on
        if not response? then return true

        # convert a boolean into JSONResponse format for consistency
        if typeof response is 'boolean'
            response =
                status:
                    type: if response then 'success' else 'error'
                    msg: ''

        # this shouldn't happen, but if response is not a JSONResponse object,
        # we can assume it should just be displayed and move on
        if not response.status?
            response =
                view: response
            return true

        # store the JSONResponse so we can pass it through to the new
        # StepHandler, rather than sending a second request
        @response = response

        # we only want to stop the transition if we're going forward in the
        # survey and the input has changed (note: inputChanged is set to true
        # by default when a step is loaded)
        canStop = response.data?.force_stop or ( @forward and (@fromHandler.firstLoad or @fromHandler.inputChanged) )
        if response.status.type is 'error'

            # add the error message to our array if there is one
            msg = response.status.msg
            if msg then @errors.push msg

            # stop the transition if needed
            if canStop
                @end()
                return false

        # continue with the transition
        return true


    end: () ->
        @displayErrors()
        @fromHandler?.firstLoad = false
        @fromHandler?.inputChanged = false

        @sppHandler.curTransition = null
        delete @sppHandler.curTransition


    displayErrors: () ->
        # use .message_writer() to show any errors that we've collected

        msg = @sppHandler.curStep.msg
        if @errors.length
            msg?.message_writer('error', @errors.join('<br/>'))
            # msg.message_writer('hide')
        else
            msg?.message_writer('clear')


    autosave: ->
        # only set this to true for debugging
        # default behavior is to condense the object for a smaller request size
        verbose = false

        # before running the SPP, we want to get rid of any skipped inputs
        if @sppHandler.taffyObjects.steps(step_order: @to).first().widget_name is 'Seed_Options'
            @taffy.fieldsAspects(skip: true).remove()

        fields = @taffy.fields(selected: true)

        # update each field with the current fieldsAspects
        for field in fields.get()

            fieldAspects = @taffy.fieldsAspects(fields_id: field.id)

            aspects = []
            if verbose
                for aspect in fieldAspects.get()
                    aspects.push
                        fid: aspect.fields_id
                        fname: aspect.field_name
                        aid: aspect.aspects_id
                        aname: aspect.aspect_name
                        v: aspect.value
                        oid: aspect.options_id
                        oname: aspect.option_name
            else
                for aspect in fieldAspects.get()
                    aspects.push
                        aid: aspect.aspects_id
                        v: aspect.value
                        oid: aspect.options_id

            # now update the taffy object
            fields.filter(id: field.id).update(aspects: aspects)


        ###
        We need to re-initialize the reference to the taffy DB after updating
        it, or else the results may be somewhat non-deterministic and sometimes
        not include the aspects set in the current step.

        In technical terms, we are creating a new 'aspects' array for each
        field. When we call update each field object, we are setting its
        'aspects' property to reference the new array object instead of the old
        one. The point I can't explain is why sometimes it appears that the
        'fields' Taffy DB uses the new reference to the array and other times it
        does not. I suspect it may have something to do with Taffy updating its
        internal database asynchronously, and that's why it gets wonky.

        I literally spent days tracking down this bug, and it sucked. I know it
        looks kind of useless, but for the love of all that is good and holy,
        DO NOT REMOVE THIS LINE OF CODE!!!
        -SK
        ###
        fields = @taffy.fields(selected: true)


        # To minimize request size, limit the columns we return.
        # I REALLY REALLY REALLY want to be able to do this using a Taffy
        # method but they completely left out the ability to return an
        # associative array AND select only specific columns. GRRRRRRR.
        fieldsArr = []
        if verbose
            for field in fields.get()
                fieldsArr.push
                    id: field.id
                    display_name: field.display_name
                    aspects: field.aspects
        else
            for field in fields.get()
                fieldsArr.push
                    id: field.id
                    aspects: field.aspects


        # send the autosave request
        # remember that @from and @to are step numbers
        postParams =
            id: @sppHandler.sppID
            result_id: @sppHandler.resultID
            fields: fieldsArr
            step_id: @taffy.steps(step_order: @from).first().id
            next_step_id: @taffy.steps(step_order: @to).first().id
            continue_if_error: not (@forward and (@fromHandler.firstLoad or @fromHandler.inputChanged))
            skipped_step_ids: @skippedStepIDs

        if (@sppHandler.operators_id)
            postParams.operators_id = @sppHandler.operators_id
        if @fromHandler.msg.length isnt 0
            @fromHandler.msg.message_writer('info', 'Saving your responses...')
        $.post 'backend/grower/placement/spp/autosave', JSON.stringify(postParams), (response) =>
            if response.data?.set_fsr_ids?
                @setFsrIds(response.data?.set_fsr_ids)

            # we can stop here if we need to
            if not @handleResponse(response) then return

            # otherwise load the next step
            @sppHandler.inputChanged = true if @fromHandler.inputChanged
            @loadToStep()
        .fail (error) =>
            if error.status is 404
                @sppHandler.parent.refresh()


    loadToStep: () ->
        @toHandler = @sppHandler.createSubHandler('step_' + @to)

        # If *somehow* the toHandler couldn't get created
        return null if not @toHandler?


        @sppHandler.curStep = @toHandler

        # pass the JSONResponse through to the StepHandler so it can use it
        @toHandler.response = @response

        if @response?.taffy?
            for name, arr of @response.taffy
                @toHandler.taffyObjects[name] = TAFFY(arr)

        # get any custom step functions from the taffy object
        stepFuncs = @taffy.steps( step_order: @to ).first()
        for name, func of stepFuncs
            if name in ['afterEnter', 'beforeLeave', 'skipConditions']
                @toHandler[name] = func

        # add the afterEnter event to the afterLoadLayout event
        @toHandler.origAfterLoadLayout = @toHandler.afterLoadLayout
        @toHandler.afterLoadLayout = (sel, response) =>
            # If we get an error response (e.g., validation), we can still
            # continue, but if the response is invalid we can't do anything.
            if not response.status?.type?
                @end()
                return

            if response?.data
                @toHandler.data ?= response.data

            @toHandler.origAfterLoadLayout(sel, response)

            if @toHandler.afterEnter?
                # we probably shouldn't ever stop here, but we can if we need to
                if not @handleResponse @toHandler.afterEnter() then return

            @end()

        # initialize the StepHandler
        @toHandler.init()


    setFsrIds: (fsr_ids) =>
        for field_id, fsr_id of fsr_ids
            @sppHandler.taffyObjects.fields(id: parseInt field_id).update(fsr_id: fsr_id)
